import { PLAYLIST_LOCAL_STORAGE_ENTITY_NAME } from "../localStoragePersistence/EntityNames";

/**
 * Playlists used to live in the LocalStorage (all schema versions share this key prefix). They come from GraphQL now
 * (ADR-11), so whatever is left there is removed without being sent; unsent changes are lost.
 */
export function removeLocalStoragePlaylists(): void {
  const keys = Array.from({ length: window.localStorage.length }, (_, i) =>
    window.localStorage.key(i),
  ).filter((key): key is string =>
    Boolean(key?.startsWith(PLAYLIST_LOCAL_STORAGE_ENTITY_NAME)),
  );
  keys.forEach((key) => window.localStorage.removeItem(key));
  if (keys.length > 0) {
    console.info(`Removed ${keys.length} playlists from the LocalStorage.`);
  }
}
